<!-- 一般廃棄物品目一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-view-module
          </v-icon>
          一般廃棄物品目
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->


    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="conditions.withoutInvisible"
                        dense
                        hide-details="auto"
                        label="非表示を表示しない"
                        persistent-hint
                        @change="searchButtonClickEvent()"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          一般廃棄物品目の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-data-table
            :headers="tableHeaders"
            :items="generalItems"
            disable-pagination
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >

            <template v-slot:[`item.disabled`]="{item}">
              <span v-if="item.disabled">非表示</span>
            </template>

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>編集</span>
              </v-btn>

              <v-btn
                v-if="item.editable"
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-trash-can-outline
                </v-icon>
                <span v-else>削除</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <general-item-regist-dialog
      :enable-dialog="enableGeneralItemDialog"
      :target-id="targetId"
      @closeEvent="closeGeneralItemDialog"
      @registerEvent="generalItemCallback"
    />
    <!-- ダイアログ -->

    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import GeneralItemRegistDialog from './dialogs/GeneralItemRegistDialog'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: 'DriverMasterGeneralItemIndex',
  components: { CustomPagination, Confirm, GeneralItemRegistDialog },
  mixins: [
    DownloadMixin
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      targetId: null,
      enableGeneralItemDialog: false,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '一般廃棄物品目名', value: 'name' },
        { value: 'sort_priority', text: '表示順', align: 'right' },
        { value: 'disabled', text: '非表示', align: 'center' },
        { text: '編集/削除', value: 'editable', align: 'end' },
      ],
      generalItems: [],
      conditions: {
        withoutInvisible: true,
      },
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // if (this.$route.params.resetCondition) {
    //   this.resetState()
    // }
    // if (this.$route.params.resetPagination) {
    //   this.resetPagination()
    // }
    // this.conditions.withoutInvisible = this.searchCondition.without_invisible;
    // this.page = this.pagination.current_page
    // this.perPage = this.searchCondition.limit
    this.searchGeneralItems()
  },
  methods: {
    ...mapActions('DriverMasterGeneralItem', {
      fetchGeneralItems: 'index',
      deleteGeneralItem: 'destroy',
    }),
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.targetId = null
      this.enableGeneralItemDialog = true
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetId = item.id
      this.enableGeneralItemDialog = true
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteGeneralItem({ id: item.id }).then(() =>{
            this.searchGeneralItems()
          })
        }
      })
    },

    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1;
      this.searchGeneralItems()
    },
    changePage(page) {
      this.page = page;
      this.searchGeneralItems()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchGeneralItems()
    },
    /**
     * モーダルを閉じる
     */
    closeGeneralItemDialog () {
      this.enableGeneralItemDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    generalItemCallback () {
      this.closeGeneralItemDialog()
      this.searchGeneralItems()
    },

     /**
     * 一般廃棄物品目検索
     */
    searchGeneralItems () {
      this.fetchGeneralItems({ without_invisible: this.conditions.withoutInvisible, page: this.page, limit: this.perPage }).then((content) => {
        this.generalItems = content.general_items
        this.pagination = content.pagination;
      })
    },
  }
}
</script>

<style scoped>

</style>
